/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/* TABS 
function openTab(evt, tabName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}
*/

/* NEW TAB fols to accordian on mobile */
(function () {
	'use strict';

 
  
	const toggleClass = function (otherElems, thisELem, className = 'is-active') {
		for (const otherElem of otherElems) {
			otherElem.classList.remove(className);
		}
		thisELem.classList.add(className);
	};
  
  const toggleVerticalTabs = function (tabContainer, tabs, items, item) {
    item.onclick = function (e) {
				const currId = item.getAttribute('id');
				const tab = tabContainer.querySelector('.ootb-tabcordion--tabs [aria-controls="' + currId + '"]');
				toggleClass(tabs, tab);
				toggleClass(items, item);
			};
  };
  
	const toggleTabs = function (tabContainer) {
		const tabs = tabContainer.querySelectorAll('.ootb-tabcordion--tabs .tab');
		const items = tabContainer.querySelectorAll('.ootb-tabcordion--entry');
		for (const tab of tabs) {
      tab.onclick = function() {
        const target = tab.getAttribute('aria-controls');
        const content = document.getElementById(target);
        toggleClass(tabs, tab);
        toggleClass(items, content);
      };
		}
		for (const item of items) {
			toggleVerticalTabs(tabContainer, tabs, items, item);
		}
	};

  const hasTabs = function(container) {
    return container.classList.contains('has-tabs');
  };
  
	const modeSwitcher = function (tabContainer, containerWidth) {
		const tabs = tabContainer.querySelectorAll('.tab');
    const container = tabs[0].closest('.ootb-tabcordion');
		let totalW = 0;
		for (const tab of tabs) {
			totalW += tab.offsetWidth;
		}
		if (totalW >= containerWidth) {
			container.classList.remove('has-tabs');
		} else {
			container.classList.add('has-tabs');
		}
	};
	
	const resizeObserver = new ResizeObserver(entries => {
		for (let entry of entries) {
			modeSwitcher(entry.target, entry.contentRect.width);
		}
	});

	const tabContainers = document.querySelectorAll('.ootb-tabcordion');
	for (const tabContainer of tabContainers) {
		const tabList = tabContainer.querySelector('.ootb-tabcordion--tabs');
		resizeObserver.observe(tabList);
		toggleTabs(tabContainer);
	}
})();